'use client';

import { createContext, useContext, type ReactNode } from 'react';
import type { SpotlightRect, FocusTargetState } from './hooks/useTourSpotlight';

interface TourSpotlightContextValue {
  spotlightRect: SpotlightRect | null;
  focusTargetState: FocusTargetState;
}

const TourSpotlightContext = createContext<TourSpotlightContextValue | null>(null);

export function TourSpotlightProvider({
  children,
  value,
}: {
  children: ReactNode;
  value: TourSpotlightContextValue;
}) {
  return <TourSpotlightContext.Provider value={value}>{children}</TourSpotlightContext.Provider>;
}

export function useTourSpotlightContext(): TourSpotlightContextValue {
  const context = useContext(TourSpotlightContext);
  if (!context) {
    return { spotlightRect: null, focusTargetState: 'idle' };
  }
  return context;
}
